import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { Pagination } from 'contracts/Pagination';
import { OperationTypeCfop } from 'contracts/OperationTypesCfop';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data', 'pagination'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'PAGINATE_OPERATION_TYPES_CFOP_',
  }
);

export interface PaginateOperationTypesCfopState {
  data: OperationTypeCfop[];
  pagination?: Pagination;
  loading: boolean;
  errorMessage: string | null;
}

export interface PaginateOperationTypesCfopRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: OperationTypeCfop[];
  pagination: Pagination;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: PaginateOperationTypesCfopState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: PaginateOperationTypesCfopState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: PaginateOperationTypesCfopState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
    pagination: { $set: action.pagination },
  });

const failure = (state: PaginateOperationTypesCfopState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: PaginateOperationTypesCfopState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const paginateOperationTypesCfop = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const PaginateOperationTypesCfopTypes = Types;
export const PaginateOperationTypesCfopActions = Creators;
